module.exports = __webpack_public_path__ + "static/media/gastronomia.2c517a40.jpg";